<template>
  <div class="new_exercise-recommend" v-show="list.length">
    <div class="new_exercise-recommend__title">推荐</div>
    <div class="new_exercise-recommend__content">
      <div class="new_exercise-recommend__list">
        <template v-for="(item, key) in list" :key="key">
          <OmoListItem
            v-if="activeTab === 'OMO'"
            :showBorder="key < list.length - 1"
            :item="item"
            :ios="ios"
          />
          <TrainItem v-else-if="activeTab === 'TEAM'" :item="item" :ios="ios" />
        </template>
      </div>
      <div class="more" @click.stop="showMore">
        <span>查看全部</span>
        <i class="icon"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import OmoListItem from '@com/list/omoListItem.vue'
import TrainItem from '@com/list/trainItem.vue'
import { hostPath } from '@utils/basePath'
import { jumpModuleApp, appPort, iOSPort } from '@/widget'
import { useRouter } from 'vue-router'
const router = useRouter()
const props = defineProps({
  list: {
    type: Array,
    default: () => {
      return []
    }
  },
  activeTab: {
    type: String,
    default: ''
  }
})
const ios = iOSPort()
const showMore = () => {
  if (appPort()) {
    const url = `${hostPath}/learn/list/${
      props.activeTab === 'TEAM' ? 'onlinetrain' : 'omo'
    }`
    jumpModuleApp({
      typeId: 'h5',
      url: url
    })
  } else {
    const path = `/list/${props.activeTab === 'TEAM' ? 'onlinetrain' : 'omo'}`
    router.push(path)
  }
}
</script>

<style lang="scss" scoped>
.new_exercise-recommend {
  padding-top: 64px;
  overflow: hidden;
  &__title {
    font-size: 0.4rem;
    color: #212224;
    margin-bottom: 0.32rem;
  }

  &__content {
    background-color: #fff;
    border-radius: 0.16rem;
    padding-bottom: 32px;
  }
  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #969799;
    font-size: 0.28rem;
    .icon {
      display: inline-block;
      margin-left: 0.04rem;
      width: 0.2rem;
      height: 0.2rem;
      background-image: url('../img/recommend_arrow.png');
      background-size: cover;
    }
  }
}
</style>
